import * as React from "react"
const IconIdioma = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.97 1.81h56.32v56.32H1.97z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M49.69 28.56v2.65l-.33 2.29c-1.45 7.77-7.66 13.98-15.43 15.42l-2.36.33c-.85-.04-1.74.05-2.58 0-16.06-.99-24.02-20.55-13.08-32.52 11.48-12.56 32.8-5.05 33.78 11.83ZM29.59 11.8c-3.59.69-5.55 4.4-6.67 7.54 2.19.48 4.43.71 6.67.8V11.8Zm1.29 0v8.34c2.15-.15 4.47-.22 6.56-.76.1-.03.12.06.12-.11 0-.22-.4-1.11-.52-1.38-1.15-2.61-3.11-5.61-6.16-6.09Zm3.94.54c1.87 1.85 3.25 4.14 4.09 6.64.22.15 3.96-1.31 4.4-1.67-2.3-2.39-5.27-4.12-8.49-4.96Zm-9.25.07c-3.16.76-6.11 2.53-8.34 4.89 0 .24 3.85 1.69 4.4 1.71.7-2.51 2.2-4.7 3.94-6.59ZM12.15 29.24h7.73c0-3.06.52-6.08 1.29-9.02-1.73-.34-3.31-1.13-4.88-1.89a18.18 18.18 0 0 0-4.14 10.91Zm36.17 0c-.07-3.94-1.58-7.91-4.13-10.89-.76.38-1.52.76-2.31 1.08-.84.33-1.75.56-2.57.91.69 2.36 1.13 4.82 1.28 7.28.03.52-.11 1.18.11 1.63h7.62Zm-18.73-7.81c-2.4-.01-4.79-.34-7.13-.83-.15.68-.36 1.35-.51 2.03-.44 2.03-.66 4.04-.7 6.12 0 .19-.15.37.03.49h8.3v-7.81Zm9.71 7.81c-.06-2.91-.45-5.82-1.29-8.61-2.35.45-4.73.81-7.13.8v7.69l.11.11h8.3Zm-19.41 1.29h-7.73c.11 3.01.98 6.01 2.52 8.59.34.57.98 1.6 1.43 2.06.08.08.13.19.26.19s2.07-.97 2.45-1.12c.78-.3 1.57-.54 2.37-.78-.79-2.91-1.27-5.91-1.29-8.94Zm9.7 0h-8.42c.11 1.5.17 3.01.39 4.5.21 1.4.59 2.77.9 4.14.54-.14 1.1-.26 1.65-.36 1.23-.2 2.6-.41 3.84-.48.52-.03 1.19.12 1.63-.11v-7.69Zm9.71 0h-8.42v7.69c.44.23 1.11.08 1.63.11 1.85.12 3.69.44 5.5.81.83-2.79 1.23-5.7 1.29-8.61Zm9.1 0h-7.81c.02 3.02-.43 6.05-1.29 8.94 1.73.44 3.35 1.16 4.96 1.9 2.12-2.63 3.56-5.85 3.98-9.23.07-.54.04-1.1.16-1.62Zm-18.81 9.09c-2.24.03-4.49.29-6.67.8 1.17 3.16 3.08 6.78 6.67 7.54v-8.34Zm1.29 0v8.26c1.01-.03 1.99-.6 2.77-1.21 1.93-1.54 3.11-4.04 3.98-6.29-2.22-.43-4.48-.75-6.75-.76Zm-9.26 1.15c-.26-.18-3.81 1.28-4.29 1.57-.05.03-.15 0-.1.13.1.24 1.49 1.39 1.78 1.63 1.94 1.52 4.24 2.7 6.63 3.26-1.84-1.84-3.26-4.09-4.03-6.59Zm13.28 6.58c3.21-.78 6.08-2.59 8.42-4.89 0-.12-1.85-.9-2.1-1-.5-.19-1.57-.63-2.05-.69-.09-.01-.17-.04-.25.02-.86 2.48-2.21 4.67-4.02 6.56Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconIdioma
